
/** @format */

import React, { useEffect } from 'react';
import { Grid, RadioGroup, FormControlLabel, Radio, Typography, Tooltip } from '@mui/material';
import { DatePicker } from 'components/LegacyPickers';
import { useStyles } from './style';
import { useFormContext } from 'react-hook-form';
import { InputV2, DatePickerPod, Icons , InputCurrency} from 'components';
import clsx from 'clsx';
import jMoment from 'moment-jalaali';
import { RadioButtonIcon, RadioButtonIconFill } from 'components/CheckBox/RadioButtonIcon';

const BaseInfo = ({
  startDate,
  handleChangeStart,
  expireDate,
  handleChangeExpire,
  setTypeOfMethod,
  typeOfMethod,
}) => {
  const url = new URL(window.location.href);
  const userName = url.searchParams.get('username');

  // -- HOOKS --//
  const methods = useFormContext();
  const { control, register, formState: { errors } } = methods;
  const classes = useStyles();

  useEffect(() => {
    handleChangeStart(jMoment(new Date().setHours(0, 0, 0, 0)));
    handleChangeExpire(jMoment(new Date().setHours(23, 59, 0, 0)).add(30, 'days'));

    if (userName) {
      methods.setValue('contactInfo', userName);
    }
  }, []);

  useEffect(() => {
    methods.register('guildCode');
    return () => {
      methods.unregister('guildCode');
    };
  }, [methods.register, methods.unregister]);

  // -- API REQUESTS --//

  return (
    <Grid container direction="row" alignItems="center" className={classes.root} item xs={12}>
      <Typography className={classes.bulkFileTitle}>
        <span className={classes.bulkFileIcon}>
          <Icons icon='wallet' color='#2b3990' size='24' />
        </span>
        حساب مبدا تفویض وجه
      </Typography>
      <Grid container spacing={0}>
        <Grid item xs={12} lg={6}>
          <RadioGroup
            style={{ marginTop: 8 }}
            row
            xs={12}
            required
            onChange={(e) => {
              setTypeOfMethod(e?.target?.value);
            }}
            value={typeOfMethod}
            defaultValue={typeOfMethod}
          >
            <Grid container xs={12} justifyContent="space-between" spacing={1}>
              <Grid item xs={12} md={6}>
                <FormControlLabel
                  disabled={typeOfMethod === 'wallet' ? false : true}
                  value="wallet"
                  className={clsx(classes.radioItem, {
                    active: typeOfMethod === 'wallet',
                  })}
                  control={<Radio className={classes.radioCircle} icon={<RadioButtonIcon />} checkedIcon={<RadioButtonIconFill />} />}
                  label={
                    <>
                      <span className={classes.radioIcon}>
                        <Icons icon='wallet' color='#2b3990' size='24' />
                      </span>
                      <Typography className={classes.radioText}>
                        حساب دیجیتال
                        <br />
                      </Typography>
                      <Tooltip
                        title="موجودی حساب دیجیتال شما هنگام خرید چک می‌شود."
                        className={classes.clickable}
                      >
                        <span className={classes.infoIcon}>
                          <Icons icon='Info' color='#667585' hover='#667585' size='20' />
                        </span>
                      </Tooltip>
                    </>
                  }
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <FormControlLabel
                  value="guild"
                  className={clsx(classes.radioItem, {
                    active: typeOfMethod === 'guild',
                  })}
                  disabled={typeOfMethod === 'guild' ? false : true}
                  control={<Radio className={classes.radioCircle} icon={<RadioButtonIcon />} checkedIcon={<RadioButtonIconFill />} />}
                  label={
                    <>
                      <span className={classes.radioIcon}>
                        <Icons icon='ShieldSuccess' color='#2b3990' size='24' />
                      </span>
                      <Typography className={classes.radioText}>حساب‌های تفصیلی</Typography>
                    </>
                  }
                />
              </Grid>
            </Grid>
          </RadioGroup>
        </Grid>
      </Grid>

      {/*  Form Container */}
      <Grid container style={{ marginTop: 8 }} spacing={1}>
        <Grid item xs={12} md={4} lg={3}>
          <InputV2
            fullWidth
            errors={errors}
            rules={['required']}
            label="نام"
            name="name"
            register={register}
            dir="ltr"
            control={control}
          />
        </Grid>
        <Grid item xs={12} md={4} lg={3}>
          <InputV2
            fullWidth
            errors={errors}
            rules={['required']}
            label="تلفن‌همراه/ایمیل/نام‌کاربری مخاطب"
            name="contactInfo"
            register={register}
            control={control}
            englishNumber
            dir="ltr"
          />
        </Grid>
      </Grid>
      <Grid container style={{ marginTop: 8 }} spacing={1}>
        <Grid item xs={12} md={6} lg={6}>
          <InputCurrency
            fullWidth
            errors={errors}
            rules={['required']}
            currency
            label="مبلغ"
            decimalPlaces={0}
            minimumValue={0}
            name="amount"
            register={register}
            control={control}
          />
        </Grid>
      </Grid>
      <Grid container style={{ marginTop: 8 }} spacing={1}>
        <Grid item xs={12} md={4} lg={3}>
          <DatePickerPod label="تاریخ شروع اعتبار" showAsterisk>
            <DatePicker
              //   {...rest}
              variant="inline"
              autoOk
              inputVariant="outlined"
              showTodayButton
              todayLabel="امروز"
              okLabel="تایید"
              cancelLabel="لغو"
              clearLabel="پاک کردن"
              labelFunc={(date) => (date ? date?.format('jYYYY/jMM/jDD 00:00') : '')}
              rules={['required']}
              value={startDate}
              onChange={handleChangeStart}
              disablePast
            />
          </DatePickerPod>
        </Grid>
        <Grid item xs={12} md={4} lg={3}>
          <DatePickerPod label="تاریخ انقضای اعتبار" showAsterisk>
            <DatePicker
              variant="inline"
              autoOk
              inputVariant="outlined"
              showTodayButton
              todayLabel="امروز"
              okLabel="تایید"
              cancelLabel="لغو"
              clearLabel="پاک کردن"
              labelFunc={(date) => (date ? date?.format('jYYYY/jMM/jDD 23:59') : '')}
              rules={['required']}
              value={expireDate}
              onChange={handleChangeExpire}
              disablePast
              {...(startDate ? { minDate: startDate } : null)}
            />
          </DatePickerPod>
        </Grid>
      </Grid>
    </Grid>
  );
};



export default BaseInfo;
